import './App.css';
import ExmlEditer from './xmlEditer';

function App() {
  return (
    <div className="">
   <ExmlEditer/>
</div>
  
  );
}

export default App;
